module.exports = __webpack_public_path__ + "static/media/realtime-bold.fe1a3d1b.woff2";